module.exports = __webpack_public_path__ + "static/media/male-yellow-v3.d328147c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/male-yellow-v3.svg
// module id = 70
// module chunks = 0